import { createBearingEnvelopeSchema } from './BearingEnvelopeSchema';

export const BeamSchema = createBearingEnvelopeSchema('beam', {
  displayName: (beam) => `Beam ${beam.name}`,
  pluralName: 'Beams',
});
